import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "input", "seasonSelect"];

  static values = {
    productName: String,
    productSkuName: String,
  };

  connect() {
    this.checkInitialModification();
  }

  checkInitialModification() {
    const patterns = [
      `${this.productNameValue} | ${this.productSkuNameValue}`,
      `${this.productNameValue} ${this.productSkuNameValue}`,
      this.productNameValue,
    ];

    this.modifiedValue = !patterns.includes(this.inputTarget.value);
  }

  async sync() {
    if (!this.modifiedValue) {
      this.inputTarget.value =
        this.selectTarget.options[this.selectTarget.selectedIndex].text;
      this.modifiedValue = false;
    }

    // Update season dropdown with seasons for the selected product SKU
    await this.updateSeasonDropdown();
  }

  async updateSeasonDropdown() {
    if (!this.hasSeasonSelectTarget) {
      return;
    }

    const selectedProductSkuId = this.selectTarget.value;
    if (!selectedProductSkuId) {
      return;
    }

    try {
      const response = await fetch(
        `/api/product_skus/${selectedProductSkuId}/seasons`
      );
      if (!response.ok) {
        console.error("Failed to fetch seasons");
        return;
      }

      const data = await response.json();
      const { seasons, currentActiveSeasonId } = data;

      // Clear existing options
      this.seasonSelectTarget.innerHTML = "";

      // Populate with new seasons
      seasons.forEach((season) => {
        const option = document.createElement("option");
        option.value = season.id;
        option.textContent = season.name;
        this.seasonSelectTarget.appendChild(option);
      });

      // Auto-select current active season if available
      if (currentActiveSeasonId) {
        this.seasonSelectTarget.value = currentActiveSeasonId;
      } else if (seasons.length > 0) {
        this.seasonSelectTarget.value = seasons[0].id;
      }

      // Show/hide season field based on availability
      const seasonContainer = this.seasonSelectTarget.closest(".col-span-6");
      if (seasonContainer) {
        seasonContainer.style.display = seasons.length > 0 ? "" : "none";
      }
    } catch (error) {
      console.error("Error updating season dropdown:", error);
    }
  }

  handleChange() {
    this.modifiedValue =
      this.selectTarget.options[this.selectTarget.selectedIndex].text.trim() !==
      this.inputTarget.value.trim();
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.handleChange);
  }
}
